import { render, staticRenderFns } from "./RsaPazienteSchedaAachenerAphasieTestModalEdit.vue?vue&type=template&id=3b5bd0fe"
import script from "./RsaPazienteSchedaAachenerAphasieTestModalEdit.vue?vue&type=script&lang=js"
export * from "./RsaPazienteSchedaAachenerAphasieTestModalEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports